import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { TenantLlmConfigView } from "./TenantLlmConfigView";
import { TenantLlmConfigViewStore } from "../../store/TenantLlmConfigViewStore";
import { useStore } from "../../../../hooks";

export const TenantLlmConfigViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/tenantLlmConfig/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new TenantLlmConfigViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <TenantLlmConfigView tenantLlmConfigViewStore={store} />
      </PageLayout>
    </div>
  );
});
